$(document).ready(function(){

    /**
     * Inizialize slideshow slick plugin
     */
    $('#slideshow-homepage').slick({
        accessibility:      false,
        arrows:             false,
        dots:               true,
        infinite:           true,
        autoplay:           true,
        autoplaySpeed:      4000,
        speed:              1500,
        slidesToShow:       1,
        slidesToScroll:     1,
        customPaging: function(slider, i) {
            return '<button type="button" data-role="none" role="button" tabindex="0">' + (i + 1) + '</button>';
        },
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    autoplaySpeed:      5000,
                    speed:              500
                }
            }
        ]
    });

    /**
     * richiamo il plugin lazy load su ogni elemento img
     * quando la slide è corrente
     * per esser sicuro che l'img venga sempre caricata
     */
    $('#slideshow-homepage').on('afterChange', function(event, slick, currentSlide, nextSlide){

        $('#slideshow-homepage .slick-current').lazyLoadXT();

        /**
         * se all'interno della slide è presente un video
         * lo faccio partire in automatico quando la slide corrente è attiva
         */
        if($(slick.$slides.get(currentSlide)).is('.slick-video')) {

            $("#video-" + currentSlide)[0].src += "&autoplay=1";

        }

    });

    /**
     * Inizialize slideshow apam informa
     */
    $('#slideshow-apam-informa').slick({
        autoplay:           true,
        arrows:             false,
        dots:               true,
        dotsClass:          'slick-dots dots-short',
        infinite:           false,
        autoplaySpeed:      5000,
        speed:              500,
        slidesToShow:       1,
        slidesToScroll:     1,
        vertical:           true,
        verticalSwiping:    true,
        customPaging: function(slider, i) {
            return '<button type="button" data-role="none" role="button" tabindex="0">' + (i + 1) + '</button>';
        }
    });
});

/**
 * Espande la visibilità delle slide mostrate
 * ed aggiorna il frontend
 */
function showSlideInSlickCarousel(target, numberSlide, numberScroll) {

    //$('#' + target).slick('unslick');

    $('#' + target).slick('slickSetOption', 'slidesToShow', numberSlide, true);
    $('#' + target).slick('slickSetOption', 'slidesToScroll', 2, true);
    $('#' + target).slick('slickSetOption', 'infinite', true, true);

}

/**
 * Chiude il pannello della registrazione abbonamento
 */
function hideRegistrationSeasonTicket() {
    $('#registration-season-ticket').fadeOut( 200, "linear", function() {
        $(this).remove();
    });
}
/**
 * Chiude il pannello dell'avviso scadenza abbonamento
 */
function hideSeasonTicket() {
    $('#user-season-ticket').fadeOut( 200, "linear", function() {
        $(this).remove();
    });
}

/**
 * Chiude il pannello delle fermate preferite
 */
function hideUseGuideFavoriteBusStops(dontChangeSlideshow) {

    //$(this).remove();
    if(dontChangeSlideshow != 1) {

        $('#use-guide-favorite-bus-stops').removeClass('show').addClass('hidden');
        $('#panels-user-interaction-group').parent().removeClass().addClass('interaction-level-c');

        showSlideInSlickCarousel('slideshow-apam-informa', '3');
    }
}

/**
 * Chiude il form di inserimento abbonamento e setta i cookie temporizzati
 */
function closeSeasonTicketRegistration(setDontShowSeasonTicketFormCookie, exdays) {

    $('#apam-informa-wrapper').removeClass('hidden');
    $('#panels-user-interaction-group').parent().removeClass().addClass('interaction-level-b');

    hideRegistrationSeasonTicket();
    //showSlideInSlickCarousel('slideshow-apam-informa', '1');

    $('#slideshow-apam-informa').slick('slickSetOption', 'autoplay', true, true);
    $('#slideshow-favourite-stops').resize();

    if(setDontShowSeasonTicketFormCookie == true) {
        $('#use-guide-favorite-bus-stops').removeClass('hidden');
        setCookie("dontShowSeasonTicketForm", exdays, exdays);
    }
}

/**
 * Chiude il form di avviso scadenza abbonamento ed elimina i cookie temporizzati
 */
function closeSeasonTicketEndAdvice() {
    eraseCookie("userSeasonTicket");
    hideSeasonTicket();
    setTimeout(function () {
        $("#use-guide-favorite-bus-stops").removeClass("hidden");
        $('#panels-user-interaction-group').parent().removeClass().addClass('interaction-level-b');
        $('#use-guide-favorite-bus-stops').fadeIn( 200, "linear", function() {
        });
    }, 200);
}

/**
 * Gestisce la registrazione dell'utente dal form
 */
$("#registration-season-ticket").find("form").submit(function (e) {

    e.preventDefault();

    $.get( Routing.generate("validate_season_ticket", {
        "name": $("#name-season-ticket").val(),
        "surname": $("#surname-season-ticket").val(),
        "number": $("#number-season-ticket").val(),
        "_": $.now()
    }), function( data ) {

        data = JSON.parse(data);

        $("#name-season-ticket").parent().find(".form-errors").empty();
        $("#surname-season-ticket").parent().find(".form-errors").empty();
        $("#number-season-ticket").parent().find(".form-errors").empty();

        if(data.result) {

            var submittedData = new Array();
            submittedData[0] = data.data.name;
            submittedData[1] = data.data.surname;
            submittedData[2] = data.data.number;

            $(".user-season-ticket-name").html(data.data.name);
            $(".user-season-ticket-number").html(data.data.number);

            $("#registration-confirmation-season-ticket").removeClass("hidden");

            setTimeout(function () {
                $('#registration-confirmation-season-ticket').fadeOut( 200, "linear", function() {
                    $(this).remove();
                    $("#use-guide-favorite-bus-stops").removeClass("hidden");
                });
            }, 6800);

            setTimeout(function () {
                if(data.data.showSeasonTicketEnd) {
                    hideUseGuideFavoriteBusStops(1);
                    $("#user-season-ticket").fadeIn( 200, "linear");
                }
            }, 7000);

            setCookie("userSeasonTicket", JSON.stringify(submittedData), 1600);
            closeSeasonTicketRegistration(false, "");

        } else {

            if(data.errors.name != "") {
                $("#name-season-ticket").parent().find(".form-errors").html("<div class='help-block'><ul><li>" + data.errors.name + "</li></ul></div>");
            }
            if(data.errors.surname != "") {
                $("#surname-season-ticket").parent().find(".form-errors").html("<div class='help-block'><ul><li>" + data.errors.surname + "</li></ul></div>");
            }
            if(data.errors.number != "") {
                $("#number-season-ticket").parent().find(".form-errors").html("<div class='help-block'><ul><li>" + data.errors.number + "</li></ul></div>");
            }
        }
    });
});